export type ContactLike = { contact_type?: string | null; contactType?: string | null; type?: string | null } & Record<string, any>;

export const normalizeContactType = (value?: string | null) => {
  if (!value) return undefined;
  const v = value.toString().toLowerCase();
  if (v === "board_member" || v === "board" || v === "vorstand") return "board_member" as const;
  if (v === "group_member" || v === "group" || v === "gruppe") return "group_member" as const;
  return undefined;
};

export const getContactCounts = (contacts: ContactLike[] = []) => {
  let board = 0;
  let group = 0;
  contacts.forEach((c) => {
    if (c.is_board_member) {
      board += 1;
      return;
    }
    const kind = normalizeContactType(c.contact_type || c.contactType || c.type);
    if (kind === "board_member") board += 1;
    else if (kind === "group_member") group += 1;
    else group += 1; // fallback: zählen als Gruppe, damit Badges nicht leer bleiben
  });
  return { board, group, total: board + group };
};
